export default __webpack_public_path__ + "static/media/NGORealCase1-en.76086b88.jpg";